import { Link } from "react-router-dom";
import { Edit, Trash2 } from "react-feather";
import { Href } from "../../../../Constant";
import { SellingProductActionsProp } from "../../../../Type/DashboardType";

export const SellingProductActions = ({deletHandler,id}:SellingProductActionsProp) => {
  return (
    <td className="text-center">
      <span className="edit-option">
        <Link to={Href}>
          <Edit/>
        </Link>
      </span>
      <span className="delete-option">
        <Link to={Href}>
          <Trash2 className="remove" onClick={() => deletHandler(id)} />
        </Link>
      </span>
    </td>
  );
};
